// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__l9W52","dragIcon":"Choice_dragIcon__1PW3m","left":"Choice_left__100o6","input":"Choice_input__37J6R"};